import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

const modal = typeof document !== 'undefined' ? document.getElementById('global-modal') : null;

export const Modal = ({
  children,
  trigger,
  slot,
}: {
  children: JSX.Element | string;
  trigger: JSX.Element;
  slot?: string;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (isModalOpen) {
      modal.setAttribute('is-open', 'true');
    } else {
      modal.removeAttribute('is-open');
    }
  }, [isModalOpen]);

  useEffect(() => {
    const close = () => setIsModalOpen(false);
    window.addEventListener('rocheModalClose', close);

    return function cleanup(): void {
      window.removeEventListener('rocheModalClose', close);
    };
  }, []);

  return (
    <>
      <div slot={slot} onMouseUp={() => setIsModalOpen(true)}>
        {trigger}
      </div>
      {isModalOpen && ReactDOM.createPortal(children, modal)}
    </>
  );
};
